import _implicitStylesheets from "./orgContextMenu.css";
import _implicitScopedStylesheets from "./orgContextMenu.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _axTooltip from "ax/tooltip";
import _wdsAvatar from "wds/avatar";
import _axIconInteractive from "ax/iconInteractive";
import _axBadge from "ax/badge";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="trigger-text-wrap${0}" data-role="trigger-text-wrap"${2}><span class="trigger-text${0}"${2}>${"t2"}</span></span>`;
const $fragment2 = parseFragment`<span class="trigger-text-wrap${0}" data-role="trigger-text-wrap"${2}><span class="trigger-text${0}"${2}>${"t2"}</span></span>`;
const $fragment3 = parseFragment`<div class="avatar${0}" aria-hidden="true"${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<div class="user-info${0}"${2}><span class="user-greeting${0}"${2}>${"t2"}</span><a${"a3:href"} class="user-link${0}" data-testid="profile"${2}>${"t4"}</a></div>`;
const $fragment5 = parseFragment`<span class="org-card-name-text${0}"${2}>${"t1"}</span>`;
const $fragment6 = parseFragment`<span class="org-card-email${0}"${2}>${"t1"}</span>`;
const $fragment7 = parseFragment`<span class="org-card-domain${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment8 = parseFragment`<button class="switch-link${0}" data-testid="switch-org"${2}>${"t1"}</button>`;
const $fragment9 = parseFragment`<div class="org-card org-card--empty${0}"${2}><button class="switch-link${0}" data-testid="select-org"${2}>${"t2"}</button></div>`;
const $fragment10 = parseFragment`<li role="presentation"${3}><div class="menu__item-divider${0}"${2}></div></li>`;
const $fragment11 = parseFragment`<li${3}><a${"a1:href"} class="menu__item${0}" tabindex="0"${"a1:data-testid"}${2}>${"t2"}</a></li>`;
const stc0 = {
  classMap: {
    "org-context-container": true
  },
  key: 0
};
const stc1 = {
  "trigger": true
};
const stc2 = {
  "trigger-cloud": true
};
const stc3 = {
  classMap: {
    "trigger-chevron": true
  },
  props: {
    "icon": "chevrondown",
    "size": "xsmall",
    "ariaHidden": "true"
  },
  key: 6
};
const stc4 = {
  classMap: {
    "trigger-chevron": true
  },
  props: {
    "icon": "chevrondown",
    "size": "xsmall",
    "ariaHidden": "true"
  },
  key: 11
};
const stc5 = {
  classMap: {
    "user-row": true
  },
  key: 13
};
const stc6 = {
  "avatar-image": true
};
const stc7 = {
  "close-button": true
};
const stc8 = {
  "data-testid": "close"
};
const stc9 = {
  classMap: {
    "org-card": true
  },
  key: 20
};
const stc10 = {
  classMap: {
    "org-card-name": true
  },
  key: 21
};
const stc11 = {
  "org-card-cloud": true
};
const stc12 = {
  classMap: {
    "org-card-meta": true
  },
  key: 29
};
const stc13 = {
  "org-context__edition": true
};
const stc14 = {
  classMap: {
    "menu__items": true
  },
  key: 35
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, ncls: api_normalize_class_name, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10} = $ctx;
  return [$cmp.showOrgContext ? api_element("div", stc0, [$cmp.isTriggerTextTruncated ? api_custom_element("ax-tooltip", _axTooltip, {
    props: {
      "theme": "dark",
      "label": $cmp.triggerLabel,
      "placement": "top"
    },
    key: 1
  }, [api_element("button", {
    classMap: stc1,
    attrs: {
      "data-role": "trigger",
      "aria-expanded": $cmp.expandedMenu,
      "aria-label": $cmp.triggerAriaLabel
    },
    key: 2,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleTriggerClick)),
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleTriggerKeyDown))
    }
  }, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc2,
    props: {
      "icon": "salesforce",
      "spriteUrl": "/images/icons.svg",
      "size": "small",
      "iconDescription": $cmp.orgIconDescription
    },
    key: 3
  }), api_static_fragment($fragment1, 5, [api_static_part(2, null, api_dynamic_text($cmp.triggerLabel))]), api_custom_element("ax-icon", _axIcon, stc3)])]) : null, !$cmp.isTriggerTextTruncated ? api_element("button", {
    classMap: stc1,
    attrs: {
      "data-role": "trigger",
      "aria-expanded": $cmp.expandedMenu,
      "aria-label": $cmp.triggerAriaLabel
    },
    key: 7,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleTriggerClick)),
      "keydown": _m3 || ($ctx._m3 = api_bind($cmp.handleTriggerKeyDown))
    }
  }, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc2,
    props: {
      "icon": "salesforce",
      "spriteUrl": "/images/icons.svg",
      "size": "small",
      "iconDescription": $cmp.orgIconDescription
    },
    key: 8
  }), api_static_fragment($fragment2, 10, [api_static_part(2, null, api_dynamic_text($cmp.triggerLabel))]), api_custom_element("ax-icon", _axIcon, stc4)]) : null, api_element("div", {
    className: api_normalize_class_name($cmp.menuClassName),
    attrs: {
      "tabindex": "0",
      "data-role": "dropdown",
      "aria-label": $cmp.triggerAriaLabel
    },
    key: 12,
    on: {
      "keydown": _m4 || ($ctx._m4 = api_bind($cmp.handleMenuKeyDown))
    }
  }, [api_element("div", stc5, [$cmp.hasProfileImage ? api_custom_element("wds-avatar", _wdsAvatar, {
    classMap: stc6,
    props: {
      "src": $cmp.profileImage,
      "alt": $cmp.greeting,
      "size": "small"
    },
    key: 14
  }) : null, !$cmp.hasProfileImage ? api_static_fragment($fragment3, 16, [api_static_part(1, null, api_dynamic_text($cmp.userInitial))]) : null, api_static_fragment($fragment4, 18, [api_static_part(2, null, api_dynamic_text($cmp.greeting)), api_static_part(3, {
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleMenuItemClick))
    },
    attrs: {
      "href": $cmp.profileUrl
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.profileLabel))]), api_custom_element("ax-icon-interactive", _axIconInteractive, {
    classMap: stc7,
    attrs: stc8,
    props: {
      "icon": "close",
      "size": "small",
      "transparentBackground": "true",
      "iconDescription": $cmp.closeLabel
    },
    key: 19,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.handleClose))
    }
  })]), $cmp.hasSelectedOrg ? api_element("div", stc9, [api_element("span", stc10, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc11,
    props: {
      "icon": "salesforce",
      "spriteUrl": "/images/icons.svg",
      "size": "small",
      "iconDescription": $cmp.orgIconDescription
    },
    key: 22
  }), api_static_fragment($fragment5, 24, [api_static_part(1, null, api_dynamic_text($cmp.orgName))])]), api_static_fragment($fragment6, 26, [api_static_part(1, null, api_dynamic_text($cmp.selectedOrg.username))]), $cmp.hasDomain ? api_static_fragment($fragment7, 28, [api_static_part(0, {
    attrs: {
      "title": $cmp.selectedOrg.domain
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.selectedOrg.domain))]) : null, api_element("span", stc12, [$cmp.hasEdition ? api_custom_element("ax-badge", _axBadge, {
    classMap: stc13,
    props: {
      "text": $cmp.selectedOrg.edition,
      "theme": $cmp.editionBadgeTheme
    },
    key: 30
  }) : null, api_static_fragment($fragment8, 32, [api_static_part(0, {
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.handleSwitchOrg))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.switchOrgLabel) + " →")])])]) : null, !$cmp.hasSelectedOrg ? api_static_fragment($fragment9, 34, [api_static_part(1, {
    on: {
      "click": _m9 || ($ctx._m9 = api_bind($cmp.handleSwitchOrg))
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.selectOrgLabel) + " →")]) : null, api_element("ul", stc14, api_iterator($cmp.menuItems, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return [it.last ? api_static_fragment($fragment10, api_key(37, it.value.id)) : null, api_static_fragment($fragment11, api_key(39, it.value.id), [api_static_part(1, {
      on: {
        "click": _m10 || ($ctx._m10 = api_bind($cmp.handleMenuItemClick))
      },
      attrs: {
        "href": it.value.link,
        "data-testid": it.value.id
      }
    }, null), api_static_part(2, null, api_dynamic_text(it.value.text))])];
  }))])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7uhch4lj1j4";
tmpl.legacyStylesheetToken = "undefined-_orgContextMenu";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
